import { createFileRoute, redirect } from '@tanstack/react-router';
import { VendorManagement } from '../components/VendorManagement';
import { isAdmin } from '../utils/roles';

export const Route = createFileRoute('/settings/vendor')({
  beforeLoad: ({ context }) => {
    const { user } = context.auth;
    if (!isAdmin(user?.role)) {
      throw redirect({
        to: '/project-settings/employee-project-models',
      });
    }
  },
  component: VendorSettingsComponent,
});

function VendorSettingsComponent() {
  return <VendorManagement />;
}
